import { Address } from '../models/address.model';
var AddressComponent = /** @class */ (function () {
    function AddressComponent() {
        this.displayCountry = false;
    }
    Object.defineProperty(AddressComponent.prototype, "FormattedPostalCode", {
        /**
         * Returns formatted zip+4
         */
        get: function () {
            if (this.address.postalCode.length === 9) {
                return this.address.postalCode.substr(0, 5) + '-' + this.address.postalCode.substr(5, 4);
            }
            else {
                return this.address.postalCode;
            }
        },
        enumerable: true,
        configurable: true
    });
    return AddressComponent;
}());
export { AddressComponent };
